import React, { memo, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import VideoContent from './contents/video';
import LockedContent from './contents/locked';
import Carousel from 'common/components/modules/carousel';
import Header from 'common/components/modules/story-player/header';
import Bottom from 'common/components/modules/story-player/bottom';
import './style.scss';

import { MediaButton } from "common/components/modules/media";


const StoryPlayer = ({
   storyType,
   title,
   timeLeft,
   date,
   timeSector,
   poster,
   src,
   commentsCount,
   muted,
   controls,
   autoPlay,
   playsInline,
   startTime,
   loop,
   bigPlayButton,
   controlBar,
   showTimeLeft,
   autoHideControlBar,
   disableDefaultControls,
   isLiked,

   onClose,
   onErrorStateChange,
   onClickComment,
   onClickLike,
   onClickShare,
   onClickLockedButton,
   isAdmin,
   nextStory,
   onDeleteStory,
   hideAfterMinutes,
   authUser,
   hasAccess,
   onDeleteImage,
   blurhash,
   onClickTip,
   id,
   onClickOpenTips,
   onClickSetId,
   totalTip,
   onFullScreenClose,
   onShare,
   isShowPage,
   siteInfo,
   onEditStory,
   pinStory,
   isPinned,
   isDemoMode,
   isBluredForSFW,
   showComments,
}) => {

   const [isShowHide, changeValue] = useState(false);
   let timeArray = [];
   let time = null;
   const stillMounted = useRef(false);

   useEffect(() => {
      stillMounted.current = true;
      return () => {
         (stillMounted.current = false);
         clearTimeout(time);
      }
   });

   const setShowFullScreenActionsButton = (value) => {
      if(timeArray.length) {
         timeArray.forEach((t) => {
            clearTimeout(t);
            const index = timeArray.indexOf(t);
            if(index > -1) {
               timeArray.splice(index, 1);
            }
         })
      }
      changeValue(value);
      if(value){
         time = setTimeout(() => {
            if(stillMounted.current) {
               changeValue(false);
            }
         }, 5000);
         timeArray.push(time)
      }
   };

   if(!hasAccess) {
      return (
         <LockedContent
            title={ title }
            date={ date }
            timeSector={ timeSector }
            timeLeft={ timeLeft }
            commentsCount={ commentsCount }
            showTimeLeft={ showTimeLeft }
            hasAccess={ hasAccess }
            isLiked={ isLiked }
            onClose={ onClose }
            onClickShare={ onClickShare }
            onClickLike={ onClickLike }
            onClickComment={ onClickComment }
            onClickLockedButton={ onClickLockedButton }
            isAuthUsers={ authUser !== null }
            hideAfterMinutes={ hideAfterMinutes }
            blurhash={ blurhash }
            isDemoMode={ isDemoMode }
            showComments={ showComments }
         />
      );
   } else {
      return storyType === 'video' ? (
         <VideoContent
            src={ src }
            poster={ poster }
            title={ title }
            date={ date }
            timeLeft={ timeLeft }
            timeSector={ timeSector }
            isLiked={ isLiked }
            startTime={ startTime }
            commentsCount={ commentsCount }
            loop={ loop }
            muted={ muted }
            controls={ controls }
            autoPlay={ autoPlay }
            hasAccess={ hasAccess }
            controlBar={ controlBar }
            showTimeLeft={ showTimeLeft }
            bigPlayButton={ bigPlayButton }
            autoHideControlBar={ autoHideControlBar }
            onClose={ onClose }
            onClickLike={ onClickLike }
            onClickShare={ onClickShare }
            onErrorStateChange={ onErrorStateChange }
            onClickComment={ onClickComment }
            disableDefaultControls={ disableDefaultControls }
            playsInline={ playsInline }
            isAdmin={ isAdmin }
            nextStory={ nextStory }
            onDeleteStory={ onDeleteStory }
            isAuthUsers={ authUser !== null }
            hideAfterMinutes={ hideAfterMinutes }
            isShowHide={ isShowHide }
            onClickTip={ onClickTip }
            id={ id }
            onClickOpenTips={ onClickOpenTips }
            onClickSetId={ onClickSetId }
            totalTip={ totalTip }
            onFullScreenClose={ onFullScreenClose }
            onShare={ onShare }
            isShowPage
            onEditStory={ onEditStory }
            pinStory={ pinStory }
            isPinned={ isPinned }
            isDemoMode={ isDemoMode }
            showComments={ showComments }
         />
      ) : (
         <div
            className='relative story-player'
            onPointerMove={ () => setShowFullScreenActionsButton(true) }
            onMouseEnter={ () => setShowFullScreenActionsButton(true) }
            onMouseLeave={ () => setShowFullScreenActionsButton(false) }
         >
            <div className={ isShowHide ? ('fixed top-0 left-0 w-screen z-20') : ('hidden') }>
               <Header
                  title={ title }
                  timeLeft={ timeLeft }
                  date={ date }
                  timeSector={ timeSector }
                  hideAfterMinutes={ hideAfterMinutes }
                  showTimeLeft={ showTimeLeft }
                  isAdmin={ isAdmin }
               />
            </div>
            <div
               className='cursor-pointer w-10 h-10 items-center justify-center flex mx-3 mt-2 absolute right-0 top-0 z-20'
            >
               <MediaButton
                  iconName='close'
                  onClick={  onFullScreenClose || onClose }
               />
            </div>
            <Carousel
               type='fullScreen'
               data={
                  {
                     full_src: src,
                     title: title,
                     created_at: date,
                     access: hasAccess,
                     hide_after_minutes: hideAfterMinutes,
                     comments_count: commentsCount,
                  }
               }
               isLiked={ isLiked }
               onClose={ onClose }
               onClickLike={ onClickLike }
               onClickShare={ onClickShare }
               onClickComment={ onClickComment }
               isAdmin={ isAdmin }
               nextStory={ nextStory }
               onDeleteStory={ onDeleteStory }
               onDeleteImage={ (index) => onDeleteImage(index) }
               isAuthUsers={ authUser !== null }
               hasAccess={ hasAccess }
               onClickTip={ onClickTip }
               id={ id }
               onTipOpen={ onClose }
               isLockedForSFW={ isBluredForSFW }
            />

            <div
               role='presentation'
               onClick={ (e) => e.stopPropagation() }
               className={ isShowHide ? ('fixed bottom-0 left-0 w-screen z-20') : ('hidden') }
            >
               <Bottom
                  commentsCount={ commentsCount }
                  hasAccess={ hasAccess }
                  isLiked={ isLiked }
                  onClickComment={ onClickComment }
                  onClickLike={ onClickLike }
                  onClickShare={ onClickShare }
                  isAdmin={ isAdmin }
                  onDeleteStory={ onDeleteStory }
                  onDeleteImage={ onDeleteImage }
                  isAuthUsers={ authUser !== null }
                  isMultiple={ false }
                  onClickTip={ onClickTip }
                  id={ id }
                  onTipOpen={ onClose }
                  onClickOpenTips={ onClickOpenTips }
                  onClickSetId={ onClickSetId }
                  totalTip={ totalTip }
                  onShare={ onShare }
                  isShowPage={ isShowPage }
                  siteInfo={ siteInfo }
                  onEditStory={ onEditStory }
                  pinStory={ pinStory }
                  isPinned={ isPinned }
                  isDemoMode={ isDemoMode }
                  showComments={ showComments }
               />
            </div>
         </div>
      );
   }
};

StoryPlayer.defaultProps = {
   disableDefaultControls: true,
};

StoryPlayer.propTypes = {
   title: PropTypes.string,
   timeLeft: PropTypes.string,
   date: PropTypes.string,
   timeSector: PropTypes.number,
   poster: PropTypes.string,
   src: PropTypes.any,
   startTime: PropTypes.number,
   commentsCount: PropTypes.number,

   storyType: PropTypes.oneOf([
      'video', 'image',
   ]),

   muted: PropTypes.bool,
   controls: PropTypes.bool,
   autoPlay: PropTypes.bool,
   playsInline: PropTypes.bool,
   loop: PropTypes.bool,
   bigPlayButton: PropTypes.bool,
   controlBar: PropTypes.bool,
   showTimeLeft: PropTypes.bool,
   autoHideControlBar: PropTypes.bool,
   disableDefaultControls: PropTypes.bool,
   hasAccess: PropTypes.bool,
   isLiked: PropTypes.bool,
   isAdmin: PropTypes.bool,
   hideAfterMinutes: PropTypes.number,

   onClose: PropTypes.func,
   onErrorStateChange: PropTypes.func,
   onClickComment: PropTypes.func.isRequired,
   onClickLike: PropTypes.func,
   onClickShare: PropTypes.func,
   onClickLockedButton: PropTypes.func,
   nextStory: PropTypes.func,
   onDeleteStory: PropTypes.func,
   onDeleteImage: PropTypes.func,
   authUser: PropTypes.object,
   // access: PropTypes.array,
   blurhash: PropTypes.string,
   onClickTip: PropTypes.func,
   id: PropTypes.number,
   onClickOpenTips: PropTypes.func,
   onClickSetId: PropTypes.func,
   totalTip: PropTypes.number,
   onFullScreenClose: PropTypes.func,
   onShare: PropTypes.func,
   isShowPage: PropTypes.bool,
   siteInfo: PropTypes.object,
   onEditStory: PropTypes.func,
   pinStory: PropTypes.func,
   isPinned: PropTypes.bool,
   isDemoMode: PropTypes.bool,
   isBluredForSFW: PropTypes.bool,
   showComments: PropTypes.bool,
};

export default memo(StoryPlayer);
